import React from "react";
import {
    Box,
    Skeleton,
    Typography,
    useTheme,
    Grid2
} from "@mui/material";
import HighchartsReact from "highcharts-react-official";
import Highcharts, { color } from "highcharts";
import { useGetEngineeringApprovalBottleneckQuery, useGetEngineeringPendingBreakdownQuery } from "store/slices/apis/engineeringDashboardSlice";
import { useParams } from "react-router-dom";

const colorPalette = [
    "#CB402D", "#FDCA41", "#415385", "#3E756D", "#C05222",
    "#57A773", "#A76D60", "#6E44FF", "#FF6B6B", "#00A9A5"
];


const LegendItem = ({ color, label }) => (
    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        <Box sx={{
            width: 10,
            height: 10,
            backgroundColor: color,
            borderRadius: "3px"
        }} />
        <Typography sx={{ fontSize: "13px", lineHeight: "20px", fontWeight: 500, color: "#182A4E" }}>{label}</Typography>
    </Box>
);

const ApprovalWorkflowBottleneck = () => {
    const theme = useTheme();
    const { projectId } = useParams();
    const { data, isLoading } = useGetEngineeringPendingBreakdownQuery({ projectId });
   

    if (isLoading) {
        return (
            <Box
                sx={{
                    padding: 2,
                    background: "#fff",
                    borderRadius: 2,
                    border: '1px solid #2525252E',
                    mb: 2,
                    height: "424px",
                    width: "100%",
                    minHeight: "100%",
                }}
            >
                <Skeleton variant="text" width={200} height={30} />
                <Skeleton variant="rectangular" height={300} />
            </Box>
        );
    }

    const chartSeriesData = data.map((item, index) => {
        const isSmall = item.count <= 20;

        return {
            y: item.count,
            color: colorPalette[index % colorPalette.length],
            dataLabels: {
                inside: !isSmall,
                align: isSmall ? "left" : "right",
                style: {
                    fontSize: "13px",
                    fontWeight: 600,
                    color: isSmall ? "#000" : "#fff",
                    textOutline: "none",
                }
            }
        };
    });


    const chartOptions = {
        chart: {
            type: "bar",
            height: 320,
            marginTop: 28,
            spacingTop: 0,
            events: {
                load: function () {
                    const chart = this;
                    chart.renderer.text("Document Count", 0, 18)  
                        .css({
                            color: "#000000",
                            fontSize: "14px",
                            fontWeight: 400,
                            lineHeight: "100%",
                            letterSpacing: "-0.4px"
                        })
                        .add();
                }
            },
        },
        title: { text: "" },
        xAxis: {
            categories: data.map((item) => item.category),
            lineWidth: 0,
            tickLength: 0,
            offset: 60,
            labels: {
               
                style: {
                    fontSize: "14px",
                    fontWeight: 500,
                    lineHeight: "100%",
                    letterSpacing: "-0.4px",
                    color: "#182A4E",
                },
            },
            opposite: false,
        },
        yAxis: {
            min: 0,
            tickLength: 5,
            tickWidth: 1,
            tickColor: "#999",
            gridLineWidth: 0,
            opposite: true,
            lineColor: "#7581954D",
            lineWidth: 1,
            labels: {
                enabled: true,
                style: {
                    fontSize: "12px",
                    color: "#414D55",
                },
                formatter: function () {
                    return this.value;
                },
            },
        },
        legend: { enabled: false },
        plotOptions: {
            series: {
                dataLabels: {
                    enabled: true,
                }
            }
        },
        series: [
            {
                name: "Documents",
                data: chartSeriesData,
            },
        ],
        credits: { enabled: false },
    };


    return (
        <Box
            sx={{
                padding: 2,
                background: "#fff",
                borderRadius: 2,
                border: '1px solid #2525252E',
                mb: 2,
                height: "450px",
                width: "100%",
            }}
        >
            <Grid2 container sx={{ mb: "33px" }}>
                <Grid2 xs={12}>
                    <Typography
                        variant="body"
                        sx={{
                            fontWeight: 500,
                            fontSize: "18px",
                            lineHeight: "100%",
                            letterSpacing: "-0.4px",
                            color: `${theme?.customSettings?.themeColor}`,
                        }}
                    >
                       Approval Status Breakdown
                    </Typography>
                    <Typography
                        sx={{
                            mt: "5px",
                            color: "#5052588A",
                            fontSize: "14px",
                            lineHeight: "100%",
                            letterSpacing: "-0.4px",
                        }}
                    >
                       Distribution of documents stuck in review
                    </Typography>
                </Grid2>
            </Grid2>
            <Grid2 container>
                <Grid2 xs={12}>
                    <Box sx={{ width: "100%" }}>
                        <HighchartsReact highcharts={Highcharts} options={chartOptions} />
                    </Box>
                </Grid2>

            </Grid2>
        </Box>
    );

};

export default ApprovalWorkflowBottleneck;
